import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import { handleRequest } from '@sagas/request';
import {
  REGISTRATIONS_INFO_CREATE_START,
  REGISTRATIONS_INFO_DELETE_START,
  REGISTRATIONS_INFO_FETCH_START,
  REGISTRATIONS_INFO_UPDATE_START,
  REGISTRATIONS_DE_REGISTER_START,
} from '@store/registrations/registrationsDetail/registrationsInfo/registrationsInfo.const';
import { REGISTRATIONS_LIST_FETCH_START } from '@store/registrations/registrationsList/registrationsList.const';
import { registrationTypesRequest } from '@store/registrations/registrationTypes';

import { registrationsInfoCreateSaga } from './registrationsInfoCreateSaga';
import { registrationsInfoDeleteSaga } from './registrationsInfoDeleteSaga';
import { registrationsInfoFetchSaga } from './registrationsInfoFetchSaga';
import { registrationsInfoUpdateSaga } from './registrationsInfoUpdateSaga';
import { registrationsListFetchSaga } from './registrationsListFetchSaga';

export default all([
  takeEvery(REGISTRATIONS_INFO_CREATE_START, registrationsInfoCreateSaga),
  takeEvery(REGISTRATIONS_INFO_DELETE_START, registrationsInfoDeleteSaga),
  takeLatest(REGISTRATIONS_INFO_FETCH_START, registrationsInfoFetchSaga),
  takeEvery(REGISTRATIONS_INFO_UPDATE_START, registrationsInfoUpdateSaga),
  takeLatest(REGISTRATIONS_LIST_FETCH_START, registrationsListFetchSaga),
  takeLatest(REGISTRATIONS_DE_REGISTER_START, handleRequest),
  takeLatest(registrationTypesRequest.type, handleRequest),
]);
